/**
 * The breadcrumb is the page title: at every depth it states where you are and
 * is the only way back up, so nothing else has to carry a back button.
 */
import { ChevronRight } from 'lucide-react';

export const DrillBreadcrumb = ({ trail, onJump }) => (
  <nav className="flex flex-wrap items-center gap-x-3 gap-y-1" data-testid="breadcrumb-nav" aria-label="Drill-down">
    {trail.map((node, i) => {
      const last = i === trail.length - 1;
      return (
        <span key={node.key} className="flex items-center gap-3">
          {i > 0 && <ChevronRight className="w-5 h-5 shrink-0" style={{ color: 'var(--text-muted)' }} />}
          <button
            type="button"
            onClick={() => !last && onJump(i)}
            aria-current={last ? 'page' : undefined}
            disabled={last}
            className={`text-2xl sm:text-3xl font-semibold tracking-tighter transition-colors ${last ? 'cursor-default' : 'hover:underline underline-offset-4'}`}
            style={{ color: last ? 'var(--text-primary)' : 'var(--text-muted)' }}
            data-testid={`breadcrumb-${node.level}`}
          >
            {node.name}
          </button>
        </span>
      );
    })}
  </nav>
);

export default DrillBreadcrumb;
